module.exports = __webpack_public_path__ + "img/key.081940f4.png";